import React from 'react';
import PhotoSwipeGallery from '@catalogo/ui-americanas-mobile-product-gallery/src/components/photo-swipe';
import { eventThumbnailContent } from '../helpers';

export const ProductGalleryZoom = ({ galleryState, onClose, images, device }) => {
  const items = images.map(image => ({
    src: image.imageListSize?.zoom,
    thumbnail: image.imageListSize?.thumbnail,
    title: 'imagem',
    w: 1000,
    h: 1000,
  }));

  return (
    <div className="product-gallery-zoom">
      <PhotoSwipeGallery
        items={items}
        isOpen={galleryState.isOpen}
        options={{ shareEl: false, index: galleryState.index, tapToToggleControls: false }}
        onClose={onClose}
        thumbnailContent={eventThumbnailContent}
      />
    </div>
  );
};

export default ProductGalleryZoom;
